<div class="p-my-3 p-d-flex p-jc-between p-ai-center p-flex-wrap">
  <span
    class="p-d-flex p-ai-center p-flex-wrap"
    style="gap: 0.5rem; row-gap: 0.5rem; min-width: 0"
  >
    <h1 class="p-m-0 p-mr-2">{{ entity.name }} ({{ entity.id }})</h1>
    <p-button
      label="Edit"
      icon="pi pi-pencil"
      styleClass="p-button-lg"
      (onClick)="navigateToEdit()"
    ></p-button>
    <p-button
      *ngIf="showCopyButton"
      icon="pi pi-copy"
      pTooltip="Copy asset info"
      tooltipPosition="top"
      styleClass="p-button-lg"
      (onClick)="copyAssetInfo()"
    ></p-button>
    <p-button
      *ngIf="showDuplicateButtons"
      label="Duplicate (New)"
      icon="fa-solid fa-copy"
      iconPos="right"
      (onClick)="showDupDialog()"
      class="p-button-secondary"
    ></p-button>
  </span>

  <span class="p-d-flex p-ai-center" style="gap: 0.5rem; margin-left: auto;">
    <p-button
      label="Localized Values"
      icon="fa fa-language"
      (onClick)="fetchLocalizedValues()"
    ></p-button>

    <app-request-translation-button
      [entityType]="type"
      [tableName]="type"
      [recordId]="+entity.id"
    ></app-request-translation-button>

    <app-ai-process-asset-button [entity]="entity" [entityRoute]="'challenges'"></app-ai-process-asset-button>
  </span>
</div>